import { render, staticRenderFns } from "./FeedbackView.vue?vue&type=template&id=457ab68a&"
import script from "./FeedbackView.vue?vue&type=script&lang=js&"
export * from "./FeedbackView.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackView.vue?vue&type=style&index=0&id=457ab68a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports